import { render, staticRenderFns } from "./confirmOrder.vue?vue&type=template&id=24cea2e9&scoped=true"
import script from "./confirmOrder.vue?vue&type=script&lang=js"
export * from "./confirmOrder.vue?vue&type=script&lang=js"
import style0 from "./confirmOrder.vue?vue&type=style&index=0&id=24cea2e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cea2e9",
  null
  
)

export default component.exports